const formatAccounting = value => {
  const formatter = new Intl.NumberFormat('en-US', {
    currency: 'USD',
    style: 'currency',
    maximumFractionDigits: 0,
  });
  return formatter.format(value);
};

export default formatAccounting;
